import React, {} from 'react';
import { useTableInstance } from '../../contexts/table_context.js';
import { GroupBySelect } from './GroupBySelect.js';
/**
 * A Multi-Select that enables the user to set columns to group by.
 *
 * To disable grouping for a specific column pass `disableGroupBy: true` to that column.
 *
 * To customize how data is aggregated for a column, pass a custom `aggregate` function.
 *
 * To customize how aggregated cells are rendered, pass a custom `Aggregated` component.
 *
 * See [useGroupBy#column-options](https://react-table-omega.vercel.app/docs/api/useGroupBy#column-options) for details.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ConnectedGroupBySelect, ConnectedTable, GroupBySelect, TableProvider } from "@panwds/react-table";
 * ```
 */
export const ConnectedGroupBySelect = () => {
    const { columns, enableRowSort, state: { groupBy }, toggleGroupBy } = useTableInstance();
    /* istanbul ignore next */
    if (enableRowSort) {
        console.error('Row sorting is not compatible with grouping. Turn off row sorting or do not render the ConnectedGroupSelect.');
    }
    return React.createElement(GroupBySelect, { columns: columns, groupBy: groupBy, toggleGroupBy: toggleGroupBy });
};
//# sourceMappingURL=ConnectedGroupBySelect.js.map